import { __assign } from "tslib";
export default (function (pluginState, action) {
    switch (action.type) {
        case 'UPDATE_STATE':
            return __assign(__assign({}, pluginState), action.data);
        default:
            return pluginState;
    }
});
//# sourceMappingURL=reducer.js.map